import { DateDuration, endOfMonth, getWeeksInMonth } from '@internationalized/date';
import { Color, Typography } from '@persona-id/design-tokens';
import { useCalendarGrid, useLocale } from 'react-aria';
import { CalendarState, RangeCalendarState } from 'react-stately';
import styled from 'styled-components';

import CalendarCell from 'design-system/components/DatePicker/Calendar/CalendarCell';

const CalendarGridContainer = styled.table`
  width: 266px;
  border-spacing: 0px;
  border-collapse: collapse;
`;

const CalendarGridDayHeader = styled.th`
  ${Typography.TextMedium};
  color: ${Color.TextSecondary};
`;

interface CalendarGridProps {
  state: CalendarState | RangeCalendarState;
  offset?: DateDuration;
}

const CalendarGrid = ({ state, offset = {} }: CalendarGridProps) => {
  const { locale } = useLocale();
  const startDate = state.visibleRange.start.add(offset);
  const endDate = endOfMonth(startDate);

  const { gridProps, headerProps, weekDays } = useCalendarGrid(
    {
      startDate,
      endDate,
    },
    state,
  );

  const weeksInMonth = getWeeksInMonth(startDate, locale);

  return (
    <CalendarGridContainer {...gridProps}>
      <thead {...headerProps}>
        <tr>
          {weekDays.map((day, index) => (
            <CalendarGridDayHeader key={index}>{day}</CalendarGridDayHeader>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...new Array(weeksInMonth).keys()].map((weekIndex) => (
          <tr key={weekIndex}>
            {state
              .getDatesInWeek(weekIndex, startDate)
              .map((date, i) =>
                date ? (
                  <CalendarCell key={i} state={state} date={date} currentMonth={startDate} />
                ) : (
                  <td key={i} />
                ),
              )}
          </tr>
        ))}
      </tbody>
    </CalendarGridContainer>
  );
};

export default CalendarGrid;
